<template>
  <!-- <p class="header"> 职工诉求</p> -->
  <van-form v-show="dataLoad" @submit="onSubmit">
    <van-field
      v-model="formValue.name"
      label="姓名"
      placeholder="姓名"
      readonly
    />
    <van-field
      v-model="formValue.company"
      label="单位"
      placeholder="单位"
      readonly
    />
    <van-field
      v-model="formValue.createTime"
      label="提交时间"
      placeholder="提交时间"
      readonly
    />
    <van-field
      v-model="formValue.content"
      label="诉求内容"
      placeholder="诉求内容"
      type="textarea"
      autosize
      readonly
    />
    <van-field
      v-show="replayTimeVisible"
      v-model="formValue.replayTime"
      label="回复时间"
      placeholder="回复时间"
      readonly
    />
    <van-field
      v-show="replayTextVisible"
      v-model="formValue.replay"
      label="回复内容"
      placeholder="回复内容"
      type="textarea"
      maxlength="500"
      show-word-limit
      autosize
      :readonly="!!replayTextDisabled"
    />

    <div v-show="submitBtnVisible" style="margin: 16px">
      <van-button
        round
        block
        type="info"
        native-type="submit"
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        >提交</van-button
      >
    </div>
  </van-form>
</template>

<script>
import service from "../../api/service";
import dayjs from "dayjs";

const RoleEnum = {
  NonExist: -1,
  Approver: 0, //审批人
  Appellant: 1, //诉求者
};

export default {
  data() {
    return {
      formValue: null,
      isHandle: 1, //诉求是否已经被处理
      role: RoleEnum.NonExist,
      dataLoad: false,
    };
  },
  created() {
    this.initFormValue();
    this.queryAppealDetail();
    this.role = this.getRoleAuth();
  },
  computed: {
    submitBtnVisible() {
      // 审批者并且没有处理
      return this.role == RoleEnum.Approver && !this.isHandle;
    },
    replayTextVisible() {
      // 审批者 或者 诉求者但是已经处理
      return (
        this.role == RoleEnum.Approver ||
        (this.role == RoleEnum.Appellant && this.isHandle)
      );
    },
    replayTextDisabled() {
      // 审批者已经处理 或者 诉求者
      return (
        (this.role == RoleEnum.Approver && this.isHandle) ||
        this.role == RoleEnum.Appellant
      );
    },
    // 已经处理了
    replayTimeVisible() {
      return this.isHandle;
    },
  },
  methods: {
    initFormValue() {
      const keyArr = [
        "name",
        "company",
        "createTime",
        "content",
        "replayTime",
        "replay",
      ];
      this.formValue = {};
      for (let key in keyArr) {
        this.formValue[key] = "";
      }
    },
    formatDate(date, format = "YYYY-MM-DD") {
      try {
        return dayjs(date).format(format);
      } catch {
        return "";
      }
    },
    onSubmit() {
      const id = this.$route.query.id;
      const replay = this.formValue.replay;

      if (!replay) {
        this.$toast("请输入回复内容！");
        return;
      }

      let params = {
        id,
        replay,
      };

      service.put("/api/appeal", params).then((res) => {
        if (!res.status == 200) {
          this.$toast(res.message);
          return;
        }
        this.queryAppealDetail();
        this.$toast("回复成功！");

        setTimeout(() => {
          this.$router.go(-1);
        }, 2000);
      });
    },
    getRoleAuth() {
      let whiteList = [
        "owgoM5xBlbOVG5EBDLj8TAiaiEX0",
        "owgoM52a6us4hPk5xTLRn9JCQXZ8",
      ];

      let user = this.$store.state.user;

      console.log(user);
      if (!user) {
        // this.$toast("用户信息不存在！");
        const openid = this.$route.query.openid;
        if (openid) user = { openid };
        else return RoleEnum.NonExist;
      }

      for (let openid of whiteList) {
        if (user.openid == openid) {
          return RoleEnum.Approver;
        }
      }
      return RoleEnum.Appellant;
    },
    queryAppealDetail() {
      const id = this.$route.query.id;

      service.post("/api/appeal/detail", { id }).then((data) => {
        this.dataLoad = true;
        let formValue = this.formValue;
        formValue["name"] = data.name;
        formValue["company"] = data.company;
        formValue["createTime"] = this.formatDate(data.created);
        formValue["content"] = data.content;
        formValue["replayTime"] = this.formatDate(data.updated);
        formValue["replay"] = data.replay;
        this.isHandle = +data.isHandle;
        this.formValue = { ...this.formValue };
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  padding: 0 16px;
  font-weight: bold;
}
</style>